/* DON'T EDIT THIS FILE: edit original and run build again */ import { TenantIndex } from "../../framework/tenant-collection/tenant-index-entry.ts";
import { getRealmsByHostAlone } from "./get-realms-by-host-alone.ts";

export const getRealmFromCurrentHostAlone = (
  tenantIndex: TenantIndex,
  location: Location,
  configGetter?: () => any
): string | null =>
  getRealmsByHostAlone(tenantIndex, configGetter)[location.hostname] ?? null;
